import TagSliderMixin from '@/components/mixins/tag-slider-mixin'
import EventBus from '@/components/mixins/event-bus-mixin'
import OnEnterMixin from '@/components/mixins/onenter-mixin'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'
import _ from 'lodash'
import CONST from '@/globals/constants'
import { mapActions, mapState } from 'pinia'
import { tagsStore } from '../../../pinia/stores/tagsStore'
import { selectionStore } from '../../../pinia/stores/selectionStore'
import { COMPONENT_KEY } from '../../../pinia/stores/storeUtils'
import Draggable from 'vuedraggable'

export default {
  name: 'tagSlider',
  inject: [
    '$currentUser',
    '$utils',
    '$dataStore',
    '$apiError',
    '$filtersRepository'
  ],
  components: {
    Draggable
  },
  props: {
    accessorComponentProp: {
      type: String,
      default () { return 'mediaFiles' }
    },
    tagsProp: {
      type: Array,
      default () { return [] }
    },
    refreshTagSliderProp: {
      type: Object,
      default () { return { ref: null, refresh: false } }
    },
    tagsSelectionRequestProp: {
      type: Object,
      default () { return { ref: null, tags: [], default: false } }
    },
    ledTagItemProp: {
      default () { return null }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    tagsProp: {
      handler (newVal, oldVal) {
        this.setDefaultData({ tags: newVal, oldTags: oldVal, tagsPropChanged: true })
      },
      deep: true
    },
    refreshTagSliderProp (newVal) {
      if (newVal && (newVal.ref && newVal.refresh)) {
        this.setDefaultData({ refreshList: true, ...newVal })
      }
    },
    accessorComponentProp (newVal) {
      this.accessorComponent = newVal
      this.setDefaultData({ tags: this.tagsProp })
    },
    editTagValue () {
      this.setDefaultTagsSliderElementStyle()
    },
    tagsSelectionRequestProp (newVal) {
      this.handleTagsSelectionRequest({ newVal })
    },
    ledTagItemProp (newVal) {
      this.ledTagItem = newVal
    },
    tags: {
      handler () {
        this.$nextTick(_ => {
          this.setElementDataHeightAttributeValue()
        })
      },
      deep: true
    },
    expanded () {
      this.$nextTick(_ => {
        this.setElementDataHeightAttributeValue()
      })
    }
  },
  mixins: [TagSliderMixin, UnsavedDataMixin, OnEnterMixin],
  data () {
    return {
      CONST,
      componentName: 'tagSlider',
      showTagsSlider: false,
      elementHeight: 0,
      isComponentUseInFilesPage: false,
      isComponentUseInLedPage: false,
      isComponentUseInVideowallPage: false,
      isComponentUseInAlertPage: false,
      isComponentUseInAdminPage: false,
      isComponentUseInSchedulePageAllPlayers: false,
      isComponentUseInPlayersPage: false,
      isComponentUseInMediaPicker: false,
      isComponentUseInMonitoringPage: false,
      isTagElDraggable: false,
      accessorComponent: this.accessorComponentProp,
      selectedTagsIndx: [],
      editTags: [],
      editTagValue: '',
      tags: [],
      tagItemColorOptions: ['#52f9e5', '#4bccdb', '#628bc8', '#7471c5', '#9443c2'],
      elTagItemWidth: 0,
      previousKeyPressedInTagsSelection: null,
      multipleTagSelection: true,
      enableCreateTags: false,
      isEditTagActionEnabled: false,
      enableDeleteTags: false,
      ledTagItem: this.ledTagItemProp,
      tagSliderComponentFirstLoad: true,
      showCollapseIcon: false,
      defaultTagSliderHeight: 39,
      lockedMediaTagsExpandAction: false,
      defaultAllTag: {
        value: CONST.ALL_TAG_VALUE,
        label: this.$t('label.all'),
        backgroundColor: '#fff'
      },

      selectedDropzoneId: null
    }
  },
  computed: {
    sortDraggableOptions () {
      return { animation: 250 }
    },
    ...mapState(tagsStore, {
      tagsStoreResourceTags: 'resourceTags',
      tagsStoreLedTags: 'ledTags',
      tagsStoreVideowallTags: 'videowallTags',
      tagsStorePlayerTags: 'playerTags',
      tagsStoreTagSliderTagCombinations: 'tagSliderTagCombinations',
      tagsStoreFetchErrors: 'error'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.FILES_SCREEN), {
      filesPageResourceSelectionData: 'resourceTags'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.PLAYERS_SCREEN), {
      playersPageResourceSelectionData: 'resourceTags'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.LED_SCREEN), {
      ledPageResourceSelectionData: 'resourceTags'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPageResourceSelectionData: 'resourceTags'
    }),
    selectedTags () {
      if (this.isComponentUseInLedPage) {
        return this.ledPageResourceSelectionData
      } else if (this.isComponentUseInVideowallPage) {
        return this.videowallPageResourceSelectionData
      } else if (this.isComponentUseInPlayersPage) {
        return this.playersPageResourceSelectionData
      } else {
        return this.filesPageResourceSelectionData
      }
    }
  },
  methods: {
    ...mapActions(tagsStore, ['fetchTags', 'saveTagSliderTagTypes', 'updateTags', 'deleteTag']),
    ...mapActions(selectionStore(COMPONENT_KEY.FILES_SCREEN), {
      filesPageUpdateResourceSelectionStateData: 'updateResourceTagsSelection'
    }),
    ...mapActions(selectionStore(COMPONENT_KEY.LED_SCREEN), {
      ledPageUpdateResourceSelectionStateData: 'updateResourceTagsSelection'
    }),
    ...mapActions(selectionStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPageUpdateResourceSelectionStateData: 'updateResourceTagsSelection'
    }),
    ...mapActions(selectionStore(COMPONENT_KEY.PLAYERS_SCREEN), {
      playerPageUpdateResourceSelectionStateData: 'updateResourceTagsSelection'
    }),
    emitEvent (action, data) {
      if (!_.isEmpty(action)) {
        _.delay(() => {
          this.$emit('tag-slider-change', {
            action,
            payload: {
              data,
              accessor: this.accessorComponent,
              tagSliderComponentFirstLoad: this.tagSliderComponentFirstLoad
            }
          })
          this.tagSliderComponentFirstLoad = false
        }, 10)
      }
    },
    setDefaultData (params) {
      this.isComponentUseInAdminPage = this.accessorComponent === CONST.COMPONENT_NAME_ADMIN_PAGE
      this.isComponentUseInFilesPage = this.accessorComponent === CONST.COMPONENT_NAME_MEDIA_FILES
      this.isComponentUseInLedPage = this.accessorComponent === CONST.COMPONENT_NAME_LED_PAGE
      this.isComponentUseInVideowallPage = this.accessorComponent === CONST.COMPONENT_NAME_VIDEOWALL_PAGE
      this.isComponentUseInAlertPage = this.accessorComponent === CONST.COMPONENT_NAME_ALERT
      this.isComponentUseInSchedulePageAllPlayers = this.accessorComponent === CONST.COMPONENT_NAME_SCHEDULE_PAGE_ALL_PLAYERS
      this.isComponentUseInPlayersPage = this.accessorComponent === CONST.COMPONENT_NAME_PLAYERS_PAGE
      this.isComponentUseInMediaPicker = this.accessorComponent === CONST.COMPONENT_NAME_MEDIA_PICKER
      this.isComponentUseInMonitoringPage = this.accessorComponent === CONST.COMPONENT_NAME_MONITORING_PAGE
      this.isComponentUseInReportingPage = this.accessorComponent === CONST.COMPONENT_NAME_REPORTING_PAGE
      this.isTagElDraggable = this.isComponentUseInFilesPage || this.isComponentUseInLedPage || this.isComponentUseInVideowallPage || this.isComponentUseInAlertPage || this.isComponentUseInPlayersPage || this.isComponentUseInAdminPage

      const tags = params?.tags ?? []

      // Set Tag selection
      let defaultSelectedTags = []
      if (this.isComponentUseInPlayersPage) {
        defaultSelectedTags = this.filterTags(this.$filtersRepository.findPlayerTags())
      } else if (this.isComponentUseInMediaPicker) {
        defaultSelectedTags = []
      } else {
        defaultSelectedTags = this.filterTags(this.$filtersRepository.findMediaTags())
      }

      // Re-select tags from params.preSelectedTags if included instead
      // of the defaultSelectedTags
      const newSelectedTags = (params?.preSelectedTags || [])
        .map((selected) => this.tags.find(t => t.value === selected.value))
        .filter((selected) => selected?.value)

      if (newSelectedTags?.length) {
        defaultSelectedTags = newSelectedTags
      }

      this.setSelectedTags(defaultSelectedTags)

      // Set Tag actions
      if (this.isComponentUseInFilesPage || this.isComponentUseInAlertPage || this.isComponentUseInLedPage || this.isComponentUseInVideowallPage) { // For Files, Alert LED page and Videowall page
        if (this.$currentUser.getRights().userCreate.editTags) {
          this.enableCreateTags = true
          this.isEditTagActionEnabled = true
          this.enableDeleteTags = true

          if (this.$currentUser.getUserTags().length) {
            this.enableDeleteTags = false
          }
        }

        if (!this.$currentUser.hasGroupUserAdmin() && this.$currentUser.hasGroupUserCreateLock()) {
          this.isEditTagActionEnabled = false
        }
      } else if (this.isComponentUseInPlayersPage && (this.$currentUser.getRights().userPlayer.editPlayer || this.$currentUser.hasGroupUserAdmin())) { // For players page actions
        this.enableCreateTags = true
        this.isEditTagActionEnabled = true
        this.enableDeleteTags = true
      }

      // Set tags and delete icon slider visibility status
      this.showTagsSlider = this.$currentUser.hasGroupExtended() && !this.isComponentUseInAlertPage

      // Disabled delete tags if userCreateLock
      if (this.$currentUser.hasGroupUserCreateLock()) {
        this.enableDeleteTags = false
      }

      // Set Tags Data per component
      if (this.isComponentUseInMonitoringPage) {
        this.showTagsSlider = true
        this.tags = this.filterTags(tags)

        this.$nextTick(_ => {
          window.setTimeout(() => {
            this.setDefaultTagsSliderElementStyle()
            this.addTagClassnameToHideOnDragging()
          }, 2)
        })
      } else {
        this.getTags(params)
      }
    },
    setElementDataHeightAttributeValue () {
      this.elementHeight = $('#tagSlider').outerHeight()
    },
    setDefaultTagsSliderElementStyle () {
      // Update page component style and watch dropdown icon visibility
      this.$nextTick(_ => {
        this.$utils.updatePageComponentStyle({ name: this.accessorComponent })
        this.validateExpandIconVisibility()
      })
    },
    filterTags (tagsSrc = []) {
      const tags = this.$utils.clone(tagsSrc)
      let newTags = []

      // Add default ALL Tag
      newTags.push({ ...this.defaultAllTag })

      // Add led tag item
      if (this.ledTagItem) {
        const isTagExist = tags.find((tag) => {
          if (typeof (tag) === 'string') {
            return this.ledTagItem === tag
          } else {
            return this.ledTagItem === tag.value
          }
        })

        if (!isTagExist) {
          tags.unshift(this.ledTagItem)
        }
      }

      tags.forEach((tag, indx) => {
        let tagItem = { value: null, backgroundColor: '' }

        if (typeof (tag) === 'string') {
          tagItem.value = tag
        } else if (this.$utils.isObject(tag)) {
          tagItem = tag

          if (tag.name) {
            tagItem.value = tag.name
          }

          if (tag.inline) {
            tagItem.inline = tag.inline
          }
        }

        if (tag.color) {
          tagItem.backgroundColor = tag.color
        } else {
          tagItem.backgroundColor = `${this.tagItemColorOptions[indx % this.tagItemColorOptions.length]}`
        }

        // For mediaListInModal tags
        if (this.isComponentUseInMediaPicker && tagItem.value.startsWith('LED:')) {
          tagItem.showLabel = this.$utils.parseLedTag(tagItem.value).name
          tagItem.backgroundColor = '#d4d4d4'
        }

        // Add to list if not exist
        const existInList = newTags.find((t) => { return t && t.value === tagItem.value })
        if (tagItem.value !== CONST.ALL_TAG_VALUE && !existInList) {
          newTags.push(tagItem)
        }
      })

      // Interchange ALL and LED: position
      if (newTags.findIndex((tag) => { return tag.value.includes('LED:') }) === 1) {
        const nTags = this.$utils.clone(newTags)
        const allIndex = 0
        const ledIndex = 1
        nTags[allIndex] = nTags.splice(ledIndex, 1, nTags[allIndex])[0]
        newTags = nTags
      }

      newTags = this.$utils.sortTags({ tags: newTags }) // Sort tags Alphabetically

      return newTags
    },
    handleContentScrollY () {
      // Prevent from scrolling if not expanded
      if (!this.expanded) {
        $(this.$refs.tagsSliderPresentation.ps.element).scrollTop(0)
      }
    },
    /**
     * Handle tags selection request from other component to directly select tags without clicking the DOM.
     * This commonly happens when remembering previous tag filters to keep selected on first load.
     */
    handleTagsSelectionRequest (params = {}) {
      const newVal = params?.newVal ?? {}

      if (newVal.ref) {
        const selectedItemsIndex = this.handleItemsSelection({
          items: this.tags,
          newItems: newVal.tags,
          default: newVal.default,
          saveAction: (params) => this.saveSelectedTagsToLocalStorage(params)
        })

        if (selectedItemsIndex) {
          this.selectedTagsIndx = selectedItemsIndex
        }
      }
    },
    getLEDResourceTagsFromAllResourceTags (resourceTags = [], ledTags = []) {
      return resourceTags.filter((resourceTag) => {
        return !_.isEmpty(ledTags.find(ledTag => ledTag.inline.includes(resourceTag.name)))
      })
    },
    getAllTagsNotInlineWithLED (allTags = [], ledTags = []) {
      return allTags.filter((resourceTag) => {
        return _.isEmpty(ledTags.find(ledTag => ledTag.inline.includes(resourceTag.name)))
      })
    },
    async getTags () {
      const getTagsRequest = async () => {
        let type = ['resourceTags', 'ledTags']

        if (this.isComponentUseInAlertPage) {
          type = ['alertTags']
        } else if (this.isComponentUseInPlayersPage || this.isComponentUseInReportingPage || this.isComponentUseInSchedulePageAllPlayers) {
          type = ['playerTags']
        } else if (this.isComponentUseInAdminPage) {
          type = ['playerTags', 'userTags', 'resourceTags']
        } else if (this.isComponentUseInMediaPicker) {
          type = ['resourceTags']
        } else if (this.isComponentUseInVideowallPage) {
          type = ['resourceTags', 'videowallTags', 'ledTags']
        }

        this.saveTagSliderTagTypes(type)

        await this.fetchTags(type)
        const resourceTags = this.tagsStoreResourceTags ?? []

        // Send new onLoad tags data to vuex store
        const allTags = this.tagsStoreTagSliderTagCombinations

        let newTags = []
        // In Led page, get led media tags from resource tags that is inline with LED
        if (this.isComponentUseInLedPage) {
          const ledTags = this.tagsStoreLedTags ?? []
          newTags = resourceTags.filter(resourceTag => !_.isEmpty(ledTags.find(ledTag => ledTag.inline.includes(resourceTag.name))))
        } else if (this.isComponentUseInVideowallPage) {
          const videowallTags = this.tagsStoreVideowallTags ?? []
          newTags = resourceTags.filter(resourceTag => !_.isEmpty(videowallTags.find(vvTag => vvTag.inline.includes(resourceTag.name))))
        } else if (this.isComponentUseInFilesPage) { // In Files page, get tags not inline with LED
          // Combine all tags except led
          newTags = []
          if (_.isPlainObject(allTags)) {
            for (const type in allTags) {
              if ((type !== 'ledTags' && type !== 'videowallTags') && _.isArray(allTags[type])) {
                for (const tag of allTags[type]) {
                  newTags.push(tag)
                }
              }
            }
          }

          if (_.isArray(allTags)) {
            newTags = allTags
          }
        } else {
          if (_.isPlainObject(allTags)) {
            for (const type in allTags) {
              if (_.isArray(allTags[type])) {
                for (const tag of allTags[type]) {
                  newTags.push(tag)
                }
              }
            }
          }

          if (_.isArray(allTags)) {
            newTags = allTags
          }
        }

        // Filter tags for the ui
        this.tags = this.filterTags(newTags)

        this.emitEvent(CONST.EMIT_EVENT_DONE_FETCHING_TAGS_FROM_SLIDER, this.tags)
        this.$nextTick(() => {
        // Adjust style
          this.setDefaultTagsSliderElementStyle()
          this.addTagClassnameToHideOnDragging()

          // Validate each selected tag if still exist in the list.If there are changes then update filtersRepository and send an event to parent component to refetch data.
          const currentSelection = _.clone(this.$filtersRepository.findMediaTags())
          const updatedSelection = _.clone(currentSelection).filter(tag => !_.isEmpty(this.tags.find(i => i.name === tag)))

          if (!this.isComponentUseInMediaPicker && !_.isEmpty(currentSelection) && _.sortedUniq(currentSelection) !== _.sortedUniq(updatedSelection)) {
            this.$filtersRepository.saveMediaTags(updatedSelection)
            this.emitEvent(CONST.EMIT_EVENT_REFETCH_PARENT_COMPONENT_LIST)
          }
        })

        if (this.tagsStoreFetchErrors) {
          this.$apiError.handleAPIRequestError(this.tagsStoreFetchErrors, { originalRequest: () => { getTagsRequest() }, showDialogNotification: false })
        }
      }
      await getTagsRequest()
    },
    saveSelectedTagsToLocalStorage (selectedTags) {
      const selectedTagsFromSlider = this.$dataStore.getStore().selectedTagsFromSlider ? this.$dataStore.getStore().selectedTagsFromSlider : {}
      selectedTagsFromSlider[this.accessorComponent] = selectedTags

      // Do not save or delete selected tags from schedule page players list if present
      if (this.accessorComponent === this.isComponentUseInPlayersPage) {
        delete selectedTagsFromSlider[CONST.COMPONENT_NAME_SCHEDULE_PAGE_ALL_PLAYERS]
      }

      this.$dataStore.setStore({ selectedTagsFromSlider })
      this.$store.dispatch('tagSliderUpdateSelectedTags', selectedTags)
    },
    removeSelectedTagsInLocalStorage (removeTag) {
      const selectedTagsFromSlider = this.$dataStore.getStore().selectedTagsFromSlider ? this.$dataStore.getStore().selectedTagsFromSlider : {}

      if (selectedTagsFromSlider[this.accessorComponent] && selectedTagsFromSlider[this.accessorComponent].indexOf(removeTag.prevVal) >= 0) {
        selectedTagsFromSlider[this.accessorComponent].splice(removeTag.prevVal, 1)
      }

      this.$dataStore.setStore({ selectedTagsFromSlider })
    },
    isCtrlKeyPressed (event = {}) {
      return event.ctrlKey
    },
    isTagSelected (tag = {}) {
      return _.isPlainObject(this.selectedTags.find(t => t.value === tag.value))
    },
    handleEditTag (tag, tagIndex) {
      if (!this.isEditTagActionEnabled) return

      this.editTags = [tag]
      this.editTagValue = tag.value

      // Focus edit tag input
      this.$nextTick(_ => {
        const targetInputEl = this.$refs[`editTagInput${tagIndex}`]

        if (targetInputEl && targetInputEl.length > 0) {
          targetInputEl[0].focus()
          targetInputEl[0].select()
        }
      })
    },
    handleTagSelection (event = {}, tag = {}) {
      let selectedTagsData = this.$utils.clone(this.selectedTags)

      // Multiple Selection
      if (this.isCtrlKeyPressed(event)) {
        if (this.isTagSelected(tag)) {
          selectedTagsData = selectedTagsData.filter(t => t.value !== tag.value)
        } else {
          selectedTagsData.push(tag)
        }

        this.previousKeyPressedInTagsSelection = 'ctrl'
      } else { // Single Selection
        if (this.isTagSelected(tag)) {
          selectedTagsData = []
        } else {
          selectedTagsData = [tag]
        }

        this.previousKeyPressedInTagsSelection = null
      }

      // Set new selection data and emit an event to parent component with the values
      this.setSelectedTags(selectedTagsData)
      this.emitEvent(CONST.EMIT_EVENT_NEW_SELECTED_TAGS_FROM_SLIDER, this.selectedTags.map(t => t.value))
    },
    setSelectedTags (tags = []) {
      if (this.isComponentUseInLedPage) {
        this.ledPageUpdateResourceSelectionStateData(tags)
      } else if (this.isComponentUseInVideowallPage) {
        this.videowallPageUpdateResourceSelectionStateData(tags)
      } else if (this.isComponentUseInPlayersPage) {
        this.playerPageUpdateResourceSelectionStateData(tags)
      } else {
        this.filesPageUpdateResourceSelectionStateData(tags)
      }

      /**
       * Save selection to filtersRepository
       * Note: For now only Files Page will use filtersRepository and keep other pages to use localStorage
       */
      const selectedTagValues = tags.filter(t => t.value !== CONST.ALL_TAG_VALUE).map((t) => t.value)
      if (this.isComponentUseInFilesPage || this.isComponentUseInAlertPage || this.isComponentUseInLedPage || this.isComponentUseInVideowallPage) {
        this.$filtersRepository.saveMediaTags(selectedTagValues)
      } else {
        this.saveSelectedTagsToLocalStorage(selectedTagValues)
      }
    },
    resetSelectedTags () {
      this.setSelectedTags([])
    },
    resetEditTag () {
      this.editTags = []
      this.editTagValue = ''
    },
    handleTagItemClick (event = {}, tag = {}, tagIndex = 0) {
      // Remove drag-active for instances of accidental dragging
      $('#tagSlider').removeClass('drag-active')

      // Prevent selection because tag is in edit state
      if (event.target && ($(event.target).hasClass('el-input__inner'))) return

      // ALL tag is selected
      if (tag.value === CONST.ALL_TAG_VALUE) {
        if (!this.selectedTags.length === 0 && !this.isComponentUseInMonitoringPage) return

        this.resetSelectedTags()
        this.resetEditTag()
        this.emitEvent(CONST.EMIT_EVENT_ALL_TAG_SELECTED_FROM_SLIDER, [])

        return
      }

      // Edit tag
      if (this.isEditTagActionEnabled && (this.isTagSelected(tag) && !this.isCtrlKeyPressed(event))) {
        this.resetEditTag()
        this.handleEditTag(tag, tagIndex)

        return
      }

      // Process tag selection
      this.handleTagSelection(event, tag)
    },
    handleConfirmEditTag (newTagValue = '', oldTagValue = '') {
      if (_.isEmpty(newTagValue.trim()) || _.isEqual(newTagValue, oldTagValue)) {
        this.setDefaultTagsSliderElementStyle()
        this.resetEditTag()

        return
      }

      // Update tag in listing
      this.tags = this.tags.map(item => {
        if (item.value === oldTagValue) {
          item.name = newTagValue
          item.value = newTagValue
        }
        return item
      })

      // Update tag from selection
      const newTagDetails = this.tags.find(t => t.value === newTagValue)
      const selectedTagsData = this.selectedTags
      selectedTagsData.map((t) => {
        if (t.value === oldTagValue) {
          return newTagDetails
        }

        return t
      })

      this.setSelectedTags(selectedTagsData)

      // Tag slider element style should be updated
      this.setDefaultTagsSliderElementStyle()

      // Emit an event to parent component
      this.emitEvent(CONST.EMIT_EVENT_UPDATING_TAG_FROM_SLIDER, { newTagValue, oldTagValue })

      // Dispatch an action in vuex to cleanup selected tags that was saved in localStorage
      if (this.isComponentUseInPlayersPage) {
        this.$store.dispatch('cleanUpSelectedTagsFromLocalStorage', {
          data: [{ name: 'playerPage', currentTags: this.tags }]
        })
      }

      this.editTagRequest(newTagValue, oldTagValue)
    },
    async editTagRequest (newTagValue = '', oldTagValue = '') {
      if (_.isEmpty(newTagValue) || _.isEqual(newTagValue, oldTagValue)) return

      const editTagRequest = async () => {
        if (this.isComponentUseInLedPage) {
          this.$utils.mainLoader(true)
        }

        let type = 'resource'

        if (this.isComponentUseInAlertPage) {
          type = 'alert'
        } else if (this.isComponentUseInPlayersPage) {
          type = 'player'
        }

        await this.updateTags(oldTagValue, newTagValue, type)

        if (this.tagsStoreFetchErrors) {
          this.$apiError.handleAPIRequestError(this.tagsStoreFetchErrors, { originalRequest: () => { editTagRequest() }, showDialogNotification: true })
        }

        // Update filters repository and send an event to parent to refetch data
        const updatedSelection = this.$filtersRepository.findMediaTags().map((tag) => {
          if (tag === oldTagValue) {
            tag = newTagValue
          }
          return tag
        })

        this.$filtersRepository.saveMediaTags(updatedSelection)
        this.emitEvent(CONST.EMIT_EVENT_REFETCH_PARENT_COMPONENT_LIST)
        this.resetEditTag()
        this.$utils.mainLoader(false)
      }
      await editTagRequest()
    },
    confirmDeleteTag (event, tag, indx) {
      // Send global event to show custom dialog
      const source = this.isComponentUseInPlayersPage ? this.$t('label.player', 2) : this.$t('label.file', 2)
      EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
        type: 'warning',
        title: this.$t('confirm.deleteTag'),
        description: this.$t('tag.deleteTagConfirmation', { source: source.toLowerCase() }),
        alert: {
          message: this.$t('tag.deleteTagWarning')
        },
        tag: {
          name: tag.value,
          color: tag.backgroundColor
        },
        confirmButtonText: this.$t('buttons.deleteTag'),
        confirmButtonIcon: 'flowbite:trash-bin-solid',
        callbacks: {
          eventOnClose: () => {},
          eventOKButtonClick: () => {
            this.handleDeleteTag(event, tag, indx)
          }
        }
      })
    },
    async handleDeleteTag (event, tag, indx) {
      let tags = this.$utils.clone(this.tags)
      const tagVal = tags[indx]
      tags.splice(indx, 1)

      if (tags.length === 1 && tags[0].value === CONST.ALL_TAG_VALUE) {
        tags = []
      }

      this.removeSelectedTagsInLocalStorage({ prevVal: tagVal.value })
      this.tags = tags
      this.setDefaultTagsSliderElementStyle()

      const deleteTagRequest = async () => {
        let type = 'resource'

        if (this.isComponentUseInAlertPage) {
          type = 'alert'
        } else if (this.isComponentUseInPlayersPage) {
          type = 'player'
        }

        this.$utils.mainLoader(true)
        await this.deleteTag(tag, type)

        if (this.tagsStoreFetchErrors) {
          this.$apiError.handleAPIRequestError(this.tagsStoreFetchErrors, { originalRequest: () => { deleteTagRequest() }, showDialogNotification: true })
        }

        this.$nextTick(_ => { this.setDefaultTagsSliderElementStyle() })
        // Send an event to parent and clear selection
        this.emitEvent(CONST.EMIT_EVENT_DELETED_TAG_FROM_SLIDER, { prevVal: tagVal.value })
        this.resetSelectedTags()
      }
      await deleteTagRequest()
    },
    onEnter (event) {
      if (event.target.id === 'tag-slider-input') {
        event.target.blur()
      }
    },
    /**
     * Sets selectedDropzoneId and adds ui-droppable-hover class to element
     */
    setSelectedDropzoneId (dropzoneId) {
      if (!dropzoneId) {
        return
      }

      const dropzone = document.getElementById(dropzoneId)
      if (dropzone) {
        this.selectedDropzoneId = dropzoneId
        dropzone.classList.add('ui-droppable-hover')
      }
    },
    /**
     * Clears selectedDropzoneId and remove ui-droppable-hover class from element
     */
    removeSelectedDropzoneId () {
      if (!this.selectedDropzoneId) {
        return
      }

      const dropzone = document.getElementById(this.selectedDropzoneId)
      if (dropzone) {
        dropzone.classList.remove('ui-droppable-hover')
      }

      this.selectedDropzoneId = null
    },
    /**
     * Handle on drag move event for setting up selectedDropzoneId
     * from event.to
     */
    handleDraggableMove (event) {
      // Disabled dragging `All` tag
      if (
        event.dragged?.classList?.contains(CONST.ALL_TAG_VALUE) ||
        event.dragged?.className?.includes(CONST.ALL_TAG_VALUE) ||
        event.draggedContext?.element?.value === CONST.ALL_TAG_VALUE
      ) {
        return false
      }

      if (event.to.id === this.selectedDropzoneId) {
        return true
      }

      this.removeSelectedDropzoneId()
      this.setSelectedDropzoneId(event.to.id)

      return true
    },
    /**
     * Handle on drag move end event for restoring selectedDropzoneId
     */
    handleDraggableEnd () {
      this.removeSelectedDropzoneId()
    },

    refreshTagList () {
      this.setDefaultData({ refreshList: true })
    }
  },
  mounted () {
    this.setDefaultData({ tags: this.tagsProp })

    /* Reset tags slider style onScroll.Tag slider content will remain active when user dropped a tag outside from the card */
    const tagSliderEl = $('#tagSlider')
    if (tagSliderEl.length) {
      tagSliderEl.bind('mousewheel', (e) => {
        const isTagSliderDragActive = $('#tagSlider').hasClass('drag-active')
        const isDragging = $('#tagSliderContent').find('.ui-draggable-dragging').length
        if (!isDragging && isTagSliderDragActive) {
          tagSliderEl.removeClass('drag-active')
        }
      })
    }

    // An event from schedule page to keep tags selection from local storage as browser history changed.
    EventBus.$on('WATCH_TAGS_SLIDER_SELECTION', (payload) => {
      this.selectedTagsIndx = []
    })
  },
  expose: ['refreshTagList']
}
